<template>
  <div class="coupon" >
    <div class="row">
      <header>
        <p class="t">积分福利</p>
        <p class="tag">天天兑好券</p>
      </header>              
      <ul class="rowBox coupon-box">
        <li class="col show"
          v-for="(item, index) in couponList" 
          :key="index"               
          @click.stop="handCoupon(index)">              
          <div class="top">
            <p class="price">
              <span class="dot number">￥</span>
              <span class="number wb">{{item.value}}</span>
            </p>
            <p class="tips">{{item.userRule}}</p>
            <p class="text">{{item.typeContent}}</p>
          </div>
          <div class="center">
            <span class="fl dot"></span>
            <span class="line"></span>
            <span class="fr dot"></span>
          </div>             
          <div class="bottom">               
            <template>                  
              <span class="btn">                
                <span class="wb">{{item.buttonName}}</span>
              </span>
            </template>             
          </div>       
        </li>
      </ul>      
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { queryMemberCouponList } from '../api/home'


export default {
  name: 'coupon',
  data() {
    return {
      couponList: null
      
    }
  },
  computed: {
    ...mapGetters(['shopId', 'luckBagCode', 'smsId'])
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      queryMemberCouponList({ appCont: 0 }).then((res) => {
        if (res.code == 0 && res.data) {
          const arr = []
          res.data.memberCouponAppInfos.forEach((item) => {
            arr.push(...item.memberCouponAppVos)
          })         
          this.couponList = arr                 
        }       
      })
    },
    handCoupon(index) {
      thinkingReport.track('click_list', {
        point_id: '26284',
        page_id: '80586',
        index: index,
        content_id: this.luckBagCode,
        sms_id: this.smsId
      })
      const { hostname } = window.location
      const y = hostname.split('.')[0]
      const userPath = y === 'spe' ? 'm.yunjiglobal.com' : 't-do-dev.yunjiglobal.com' // 拉起app的现网域名就是m.yunjiglobal.com
      const targetUrl = 'yunji://memberCenter' 
      window.location.href = `
      ${window.location.protocol}//${userPath}/yjbuyer/seller-link?shopId=${this.shopId}&goType=callAppWebUrl&openUrl=${encodeURIComponent(targetUrl)}`
    }
  }
}
</script>

<style lang="stylus" scoped>
  .coupon{
    width 100%
    height 4.48rem
    padding 0 0.24rem
    margin 0.4rem auto
    .row{
      width 100%
      height 100%
      background #FFEEEE
      border-radius 0.2rem
      padding 0.4rem 0 
      header{
        display flex
        align-items:baseline
        margin-bottom 0.4rem
        padding-left 0.24rem
        .t{
          font-size: 0.36rem;
          color: #DC0000;
          line-height: 0.44rem;
          font-weight bold
          margin-right 0.2rem
        }
        .tag{
          font-size: 0.24rem;
          color: #EE2532;          
          line-height: 0.32rem;
        }
      }
      .rowBox{        
        overflow-x: auto;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;  
        padding-left 0.24rem      
        &::-webkit-scrollbar{display:none;}          
        &.coupon-box{     
          height: 2.84rem;
          display: flex;
          align-items: center;
          margin-bottom: 0.24rem;
          min-width: 1.96rem;          
          .col{
            width: 1.96rem;            
            height: inherit;
            background-image: linear-gradient(136deg, #FF8600 0%, #FF313B 100%);
            border-radius: 0.16rem;
            display: flex;        
            align-items: center;
            flex-direction: column;       
            margin-right: 0.16rem; 
            position: relative;            
            &.show{
              .future{
                .btn{
                  background: #D90000;
                  color: #FFE3C1
                }
              }
            }       
            .lab{
              min-width: 1.08rem;
              height: 0.28rem;
              display: inline-block;
              background-image: linear-gradient(136deg, #FF8600 0%, #FF313B 100%);
              border-radius: 0.14rem 0.14rem 0.14rem 0;
              line-height:0.28rem;
              text-align: center;
              position: absolute;
              padding: 0 0.08rem;
              left: 0;
              top: -0.135rem;
              span{
                font-size: 0.18rem;
                color: #5F290F;
                white-space: nowrap
              }
            }
            .tags{
              position: absolute;
              left: 0;
              top: 0;
              width: 1.1rem;
              height: 1.1rem;
              z-index: 0;
              img{width: 100%}
            }
            .top{
              color: #fff;
              margin-top: 0.48rem;    
              margin-bottom: 0.12rem;  
              display: flex;
              flex-direction: column;
              align-items: center; 
              height: 1.4rem; 
              .price{
                position: absolute;
                left: 50%;
                transform: translateX(-50%)
              }                   
              .wb{
                font-size: 0.72rem;
              }
              .dot{
                font-size: 0.24rem;
              }
              .tips{
                margin-top: 0.6rem;
                font-size: 0.24rem;
              }
              .text{
                display: block;
                font-size: 0.24rem;
                white-space: nowrap;
                width: 1.96rem;
                text-overflow: ellipsis;           
                line-height: 0.24rem;
                overflow: hidden;
                text-align: center;
              }
            }
            .center{
              width: 100%;
              height: 0.22rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              position: relative;
              .line{
                width: 1.5rem;
                height: 1px;
                border-bottom:1px dashed #fff;
                margin: auto;           
              }
              .dot{
                display: inline-block;
                width: 0.22rem;
                height: 0.22rem;
                background: #FFEEEE;
                border-radius: 100%;
                position: absolute;
                z-index: 3;
              }
              .fl{left: -0.11rem}
              .fr{right: -0.11rem}
            }      
            .bottom{
              height: 1rem;
              width: 100%;      
              display: flex;
              justify-content: center;          
              .btn{
                display: inline-flex;
                min-width: 1.56rem;
                height: 0.56rem;
                padding: 0 0.2rem;
                justify-content: center;
                align-items: center;      
                color: #fff;
                background: #D90000;
                border-radius: 0.56rem;
                box-sizing: border-box;
                margin-top: 0.12rem;                
                .wb{
                  font-size: 0.22rem;
                  font-weight: bold;
                  white-space: nowrap;
                  line-height: .22rem;
                }           
              }   
            }
          }
        }     
      }
    }
  }
</style>
